
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import TechnologySection from './components/TechnologySection';
import MarketsSection from './components/MarketsSection';
import DifferentialsSection from './components/DifferentialsSection';
import FutureSection from './components/FutureSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <TechnologySection />
        <MarketsSection />
        <DifferentialsSection />
        <FutureSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
